/* Made by Swami — storefront interactions
   Cart drawer, AJAX add/remove, and product variant selection. */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  var mobileNav = document.getElementById('MobileNav');
  var toastEl = document.getElementById('ToastNotice');
  var toastTimer = null;

  /* ---------- helpers ---------- */
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      var s = new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
      return s.replace(/\.00$/, '');
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- cart drawer open/close ---------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- mobile nav drawer open/close ---------- */
  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-nav-toggle]')) { e.preventDefault(); openMobileNav(); }
    if (e.target.closest('[data-mobile-nav-close]')) { e.preventDefault(); closeMobileNav(); }
    if (e.target.closest('.mobile-nav__link')) { closeMobileNav(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileNav();
  });

  /* ---------- update cart UI from section HTML ---------- */
  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();

    if (sections['cart-drawer'] && drawer) {
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      var newItems = doc.querySelector('[data-cart-items]');
      var curItems = drawer.querySelector('[data-cart-items]');
      if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

      var newSub = doc.querySelector('[data-cart-subtotal]');
      var curSub = drawer.querySelector('[data-cart-subtotal]');
      if (newSub && curSub) curSub.textContent = newSub.textContent;

      var newCheckout = doc.querySelector('[data-cart-checkout]');
      var curCheckout = drawer.querySelector('[data-cart-checkout]');
      if (newCheckout && curCheckout) curCheckout.className = newCheckout.className;
    }

    if (sections['header']) {
      var hdoc = parser.parseFromString(sections['header'], 'text/html');
      var newCount = hdoc.querySelector('[data-cart-count]');
      var curCount = document.querySelector('[data-cart-count]');
      if (newCount && curCount) {
        curCount.textContent = newCount.textContent;
        if (newCount.hasAttribute('hidden')) curCount.setAttribute('hidden', '');
        else curCount.removeAttribute('hidden');
      }
    }
  }

  function refreshCount() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('[data-cart-count]');
        if (!el) return;
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
  }

  var SECTIONS = ['cart-drawer', 'header'];

  /* ---------- add to cart ---------- */
  function addToCart(id, qty) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1, sections: SECTIONS, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#product-form');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[data-variant-id]') || form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('is-disabled');
    addToCart(idInput.value, 1).then(function (res) {
      if (res && res.status && res.status >= 400) {
        toast(res.description || 'Could not add to bag.');
      } else {
        applySections(res.sections);
        if (!(res && res.sections)) refreshCount();
        toast('Added to your bag.');
        openDrawer();
      }
    }).catch(function () {
      toast('Could not add to bag.');
    }).then(function () {
      if (btn) btn.classList.remove('is-disabled');
    });
  });

  /* ---------- remove line ---------- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: rm.getAttribute('data-cart-remove'), quantity: 0, sections: SECTIONS, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (res) { applySections(res.sections); if (!(res && res.sections)) refreshCount(); });
  });

  /* ---------- product variant selection ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root || !root.getAttribute('data-variants')) return;
    var variants;
    try { variants = JSON.parse(root.getAttribute('data-variants')); } catch (e) { return; }

    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));
    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var atcText = root.querySelector('[data-atc-text]');
    var atcBtn = root.querySelector('[data-add-to-cart]');
    var colorLabel = root.querySelector('[data-selected-color]');
    var mainImg = root.querySelector('[data-main-image]');

    function selectedOptions() {
      var byPos = {};
      inputs.forEach(function (inp) {
        if (inp.checked) byPos[inp.getAttribute('data-option-position')] = inp.value;
      });
      var arr = [];
      Object.keys(byPos).sort().forEach(function (k) { arr.push(byPos[k]); });
      return arr;
    }

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function syncVisualState() {
      // swatches
      root.querySelectorAll('.swatches label').forEach(function (label) {
        var inp = label.querySelector('[data-option-input]');
        var sw = label.querySelector('[data-swatch]');
        if (inp && sw) sw.classList.toggle('is-selected', inp.checked);
      });
      // bundles
      root.querySelectorAll('.bundle').forEach(function (b) {
        var inp = b.querySelector('[data-option-input]');
        if (inp) b.classList.toggle('is-selected', inp.checked);
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = matchVariant(opts);
      syncVisualState();
      if (colorLabel) {
        inputs.forEach(function (inp) {
          var label = inp.closest('label');
          if (inp.checked && label && label.querySelector('[data-swatch]')) colorLabel.textContent = inp.value;
        });
      }
      if (!v) {
        if (atcBtn) { atcBtn.setAttribute('disabled', ''); }
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (atcBtn) {
        if (v.available) { atcBtn.removeAttribute('disabled'); if (atcText) atcText.textContent = 'Add to Cart — ' + money(v.price); }
        else { atcBtn.setAttribute('disabled', ''); if (atcText) atcText.textContent = 'Sold out'; }
      }
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.src = v.featured_image.src;
      }
    }

    inputs.forEach(function (inp) { inp.addEventListener('change', update); });
    update();

    // thumbnail gallery
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.getAttribute('data-thumb');
        mainImg.alt = t.getAttribute('data-thumb-alt') || mainImg.alt;
        root.querySelectorAll('.product__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initProduct);
})();
